import ViewChannelDisplay from './ViewChannelDisplay'

export default ViewChannelDisplay
